export enum EPromptsVariables {
  REPLY_VARIABLE = '{{tweet_message}}',
  CHATBOT_REPLY_VARIABLE = '{{user_message}}',
  COMMON_TRAICY_VARIABLE = '{{user_message}}',
  MENTION_TRAICY_VARIABLE = '{{mention_message}}',
  SCAN_TO_EARN_BARCODE_VARIABLE = '{{barcode_id}}',
  SCAN_TO_EARN_IMPACTS_LIST_VARIABLE = '{{impacts_list}}',
  SCAN_TO_EARN_ACCOUNT_NAME_VARIABLE = '{{account_name}}',
  SCAN_TO_EARN_PRODUCT_NAME_VARIABLE = '{{product_name}}',
  SCAN_TO_EARN_PRODUCT_DESCRIPTION_VARIABLE = '{{product_description}}',
  SCAN_TO_EARN_PRODUCT_TYPE_VARIABLE = '{{product_type}}',
  SCAN_TO_EARN_SCANNER_LONGITUDE_VARIABLE = '{{scanner_longitude}}',
  SCAN_TO_EARN_SCANNER_LATITUDE_VARIABLE = '{{scanner_latitude}}',
  LANGUAGE_TO_TRANSLATE = '{{language_to_translate}}',
  VALUE_TO_TRANSLATE = '{{value_to_translate}}',
  TWEET_GENERATED_TEXT = '{{generated_text}}',
  ENTITY_DESCRIPRION_PROMPT = '{{entity_description_prompt}}',
  LANGUAGE_CODE = '{{language_code}}',
  USER_PROMPT = '{{user_prompt}}',
  TG_BOT_BARCODE = '{{barcode_id}}',
  TG_BOT_ACCOUNT_NAME = '{{account_name}}',
  TG_BOT_PRODUCT_NAME = '{{product_name}}',
  TG_BOT_PRODUCT_TYPE = '{{product_type}}',
  TG_BOT_USER_TX_LINK = '{{tx_hash_link}}',
  TG_BOT_COUNTRY_FLAG = '{{country_flag}}',
  TG_BOT_USER_NAME = '{{user_name}}',
  TG_BOT_APPROVED_SCANS_COUNT = '{{approved_scans_count}}',
  TRAICY_CHATBOT_API_RESP_FORMAT = '{{response_format}}',
  TWEET_TEXT = '{{tweet_text}}',
  TRADE_SETUPS = '{{trade_setups}}',
  USER_HANDLE = '{{user_handle}}',
  REPLY_TWEET_TEXT = '{{reply_tweet_text}}',
  IS_IMAGE_INCLUDED = '{{is_image_included}}',
  SEARCH_TEXT = '{{search_text}}',
}

export enum EPromptsGlobalVariables {
  LATEST_X_TRENDS = '{{latest5-x-trends}}',
  LATEST_CRYPTO_TRENDS = '{{latest5-crypto-trends}}',
  LATEST_ESG_TRENDS = '{{latest5-esg-trends}}',
}

export enum EPromptsGlobalImageVariables {
  IMAGE_1 = '{{image_1}}',
  IMAGE_2 = '{{image_2}}',
  IMAGE_3 = '{{image_3}}',
  IMAGE_4 = '{{image_4}}',
  IMAGE_5 = '{{image_5}}',
}
